// W8ED THINKING — the editorial publication. Articles are stubs until published.
export const ARTICLES = [
  {
    slug: "the-body-is-a-system",
    title: "THE BODY IS A SYSTEM.",
    topic: "Systems",
    status: "COMING SOON",
    excerpt: "Nutrition here. Fitness there. Sleep somewhere else. Biology does not work in categories.",
  },
  {
    slug: "you-are-what-you-repeat",
    title: "YOU ARE WHAT YOU REPEAT.",
    topic: "Behaviour",
    status: "COMING SOON",
    excerpt: "A single workout matters. But repeated signals over months and years matter differently.",
  },
  {
    slug: "discipline-over-dopamine",
    title: "DISCIPLINE > DOPAMINE.",
    topic: "Behaviour",
    status: "COMING SOON",
    excerpt: "Dopamine is not the enemy. The imbalance between immediate reward and future outcome is the problem.",
  },
  {
    slug: "why-muscle-matters",
    title: "WHY MUSCLE MATTERS.",
    topic: "Muscle",
    status: "COMING SOON",
    excerpt: "Muscle is not aesthetic. It is metabolic capacity, resilience and independence.",
  },
  {
    slug: "time-changes-everything",
    title: "TIME CHANGES EVERYTHING.",
    topic: "Time",
    status: "COMING SOON",
    excerpt: "The same signal means one thing once, and something else entirely repeated for a decade.",
  },
  {
    slug: "youre-not-lazy",
    title: "YOU'RE NOT LAZY.",
    topic: "Behaviour",
    status: "COMING SOON",
    excerpt: "Most environments are engineered for immediate reward. Willpower was never the whole story.",
  },
  {
    slug: "health-is-compound-interest",
    title: "HEALTH IS A LONG-TERM COMPOUND INTEREST PROBLEM.",
    topic: "Time",
    status: "COMING SOON",
    excerpt: "The returns on repeated signals arrive late — and then all at once.",
  },
  {
    slug: "what-your-food-is-really-telling-your-body",
    title: "WHAT YOUR FOOD IS REALLY TELLING YOUR BODY.",
    topic: "Nutrition",
    status: "COMING SOON",
    excerpt: "Food is information, fuel and material — and the body reads all three.",
  },
];

export const articleBySlug = (slug) => ARTICLES.find((a) => a.slug === slug);
